export default "__VITE_ASSET__19ca3693__"